import Button from '@/common/components/base/button/Button';
import LoadingButton from '@/common/components/base/button/loadingButton';
import { getCulpritPreviousCorrectiveImagesOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritPreviousCorrectiveImages/getCulpritPreviousCorrectiveImagesOptions';
import { postCulpritDamagedVehicleCorrectiveImagesOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/postCulpritDamagedVehicleCorrectiveImages/postCulpritDamagedVehicleCorrectiveImagesOptions';
import { useCorrectiveImages } from '@/modules/adjusterReportModules/IncidentParticipants/store/correctiveImages/useCorrectiveImages';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Flex } from 'styled-system/jsx';

const PostCulpritButton = () => {
  const { mutate: PostCulpritDamaged, isPending } = useMutation(
    postCulpritDamagedVehicleCorrectiveImagesOptions(),
  );
  const client = useQueryClient();
  const { id } = useParams();
  const { selectedDamagedParts, selectedDocuments, selectedVehicle, reset } =
    useCorrectiveImages();
  const validButton = useMemo(() => {
    if (
      selectedDamagedParts.length !== 0 ||
      selectedDocuments.length !== 0 ||
      selectedVehicle.length !== 0
    ) {
      return false;
    }
    return true;
  }, [selectedDamagedParts, selectedDocuments, selectedVehicle]);

  const onSubmit = () => {
    PostCulpritDamaged(
      {
        id: +id!,
        body: {
          damaged: selectedDamagedParts.map((item) => item.enNameOrId),
          document: selectedDocuments.map((item) => item.enNameOrId),
          vehicle: selectedVehicle.map((item) => item.enNameOrId),
        },
      },
      {
        onSuccess: () => {
          reset();
          client.invalidateQueries({
            queryKey: getCulpritPreviousCorrectiveImagesOptions({
              id: +id!,
            })?.queryKey,
          });
        },
      },
    );
  };

  return (
    <Box>
      <Flex gap={8}>
        <Button
          w="100%"
          mt={40}
          onClick={onSubmit}
          disabled={validButton || isPending}
        >
          {isPending && <LoadingButton color={'primary'} loading={isPending} />}
          ثبت
        </Button>
      </Flex>
    </Box>
  );
};

export default PostCulpritButton;
